import React, { useRef, useState } from "react";
import axioAdmin from "../../../services/intercepters";
import { API_URL } from "../../../services/url-constant";
import { toastEmitter } from "../../../utills/utilities";
import { LOGO_IMG } from "../../../utills/image-constant";
import UploadModel from "../../components/common/UploadModal";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "../../routes/url-constant";
import TableHeading from "../../components/common/TableHeading";
import { compose } from "@reduxjs/toolkit";
import { API_RESPONSE } from "../../../utills/app-constant";
import EmployeeBulkUpload from "./EmployeeBulkUpload";

const BulkUpload = () => {
    const [modelData, setModelData] = useState("");
    const [selectedFileName, setSelectedFileName] = useState("");
    const [modalOpen, setModalOpen] = useState(false);
    const [uploadApi, setUploadApi] = useState(false);
    const [formDataValue, setformDataValue] = useState(null);
    const [formValue, setformValue] = useState(null);
    const [loading, setLoading] = useState(false)
    const navigate = useNavigate();
    // API function
    //   const uploadBulk = async (formData) => {
    //     if (!formData) throw new Error("No file selected");
    //     try {
    //       const response = await axioAdmin.post(
    //         `${API_URL?.BulkUpload?.allBulkUpload}`,
    //         formData
    //       );
    //       return response.data;
    //     } catch (error) {
    //       console.error("Error in uploadBulk:", error);
    //       throw error;
    //     }
    //   };


    // Handle CSV file selection

    const dropRef = useRef(null);

    // Handle file selection (from input or drop)
    const handleFile = (file) => {
        if (!file || file.type !== "text/csv") {
            toastEmitter("error", "Please upload a valid CSV file!");
            return;
        }

        const formdata = new FormData();
        formdata.append("file", file);
        setSelectedFileName(file.name);
        setformDataValue(formdata);
        setUploadApi(true);
        setModalOpen(true);
    };

    const handleChange = (event) => {
        const file = event.target.files[0];
        handleFile(file);
        event.target.value = null;
    };

    // Drag & Drop handlers
    const handleDragOver = (event) => {
        event.preventDefault();
        dropRef.current.classList.add("drag-over");
    };

    const handleDragLeave = (event) => {
        event.preventDefault();
        dropRef.current.classList.remove("drag-over");
    };

    const handleDrop = (event) => {
        event.preventDefault();
        dropRef.current.classList.remove("drag-over");

        const file = event.dataTransfer.files[0];
        handleFile(file);
    };

    const handlebulkuploadModal = async () => {
        if (!uploadApi || !formDataValue) return;
        try {
            setLoading(true);
            const response = await axioAdmin.post(
                `${API_URL?.BulkUpload?.allBulkUpload}`,
                formDataValue
            );
            if (response.data?.responseCode === 200) {
                toastEmitter(
                    "success",
                    response?.message || "CSV uploaded successfully!"
                );
                setModalOpen(false);
                setformValue(null);
                setModelData("");
                setUploadApi(false);
                setSelectedFileName("");
                setformDataValue(null);
            }
            else if (response.data?.responseCode === 400) {
                toastEmitter("error", response.data?.message || "Upload failed");
                setModalOpen(false);
                setformValue(null);
                setModelData("");
                setUploadApi(false);
            } else {
                toastEmitter("error", response?.message || "Something went wrong");
            }
        } catch (error) {
            toastEmitter("error", API_RESPONSE?.MESSAGE_503);
        } finally {
            setLoading(false);
        }
    };

    // Handle download CSV template
    const handleDownload = () => {
       const baseUrl = API_URL.fileURL; // dynamic base URL
        const link = document.createElement("a");
        // const locale = navigator.language || "en-US";
        // const commaLocales = ["en-US","en", "en-IN", "en-GB", "en-CA", "en-AU"];
        // const isComma = commaLocales.some(l => locale.startsWith(l));
        // if(isComma==true){
        //   link.href = `${baseUrl}/en/Modalbulkupload.csv`;
        // }else{
        //   link.href = `${baseUrl}/fr/Modalbulkupload.csv`;
        // }
        link.href = `${baseUrl}/fr/Modalbulkupload.csv`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    return (
        <>
            <div className="d-flex justify-content-between ">
                <TableHeading
                    firstData="Model Bulk Upload"
                    className="fs-18"
                    TableHeading="align-items-center d-flex justify-content-center "
                />

                <div className="px-3">
                    <button className="btn btn-primary fs-md-12 px-md-3 px-2" onClick={handleDownload}>
                        Download CSV Format
                    </button>
                </div>
            </div>

            <div className="p-3">
                <div className="Bulk_upload">
                    <div
                        ref={dropRef}
                        className=" p-5 d-flex flex-column justify-content-center align-items-center text-center  border-dashed"
                        onDragOver={handleDragOver}
                        onDragLeave={handleDragLeave}
                        onDrop={handleDrop}
                        style={{ minHeight: "200px", cursor: "pointer" }}
>            <p className="mb-1 dropzone-text">
                            <strong>Select a CSV file to upload</strong>
                        </p>
                        <p className="mb-3 text-muted small">or drag and drop it here</p>
                        <button
                            type="button"
                            className="btn btn-danger px-md-5 fs-md-12 px-3"
                            onClick={() => document.getElementById("file-upload").click()}
                        >
                            Upload CSV
                        </button>
                        <input
                            id="file-upload"
                            type="file"
                            onChange={handleChange}
                            style={{ display: "none" }}
                        />
                    </div>

                    <UploadModel
                        modalOpen={modalOpen}
                        setModalOpen={setModalOpen}
                        uploadApi={uploadApi}
                        setUploadApi={setUploadApi}
                        handlebulkupload={handlebulkuploadModal}
                        selectedFileName={selectedFileName}
                        setModelData={setModelData}
                        loading={loading}
                    />
                </div>
            </div>

        </>
    );
};

export default BulkUpload;
